var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVegetarian = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 14.333c0-2 1.233-3.573 3.387-4 1.613-.32 3.28-1.333 3.946-2M8 13.667A4.667 4.667 0 0 1 7.2 4.4c3.8-.733 4.8-1.08 6.133-2.733C14 3 14.667 4.453 14.667 7c0 3.667-3.187 6.667-6.667 6.667Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgVegetarian;